// Minimal entry point. Loads runtime config FIRST, then dynamic-imports the app so every
// module that reads config (axiosConfig -> config.ts, msalInstance -> msalConfig, api.ts,
// Stripe, reCAPTCHA) initialises with config already available.
// Build once, promote many (spec 20260701-runtime-spa-config-build-once-promote-many).

import { stampBundleAtBoot } from "./bundleStamp";
import { loadRuntimeConfig } from "./runtimeConfig";

stampBundleAtBoot();

function renderConfigError(): void {
  const root = document.getElementById("root");
  if (root) {
    root.innerHTML =
      '<div style="font-family:system-ui,sans-serif;max-width:520px;margin:15vh auto;padding:0 24px;color:#333;text-align:center">' +
      '<h1 style="font-size:20px;margin:0 0 12px">Configuration unavailable</h1>' +
      '<p style="color:#666;line-height:1.5">The application could not load its configuration. ' +
      "Please refresh in a moment. If this persists, contact support.</p></div>";
  }
}

loadRuntimeConfig()
  .then(() => import("./bootstrap"))
  .then((m) => m.renderApp())
  .catch((err) => {
    // Deployed build fails closed: never fall back to a wrong environment or a blank page.
    // eslint-disable-next-line no-console
    console.error("Failed to load runtime configuration:", err);
    renderConfigError();
  });
